import { shallowEqual, useSelector } from 'react-redux';
import { getBanTime } from '../selectors';

export const useUserBanTime = () => ({
  banTime: useSelector(getBanTime, shallowEqual),
});
